export default "__VITE_ASSET__DB9wL3QD__"